import { APP_STORE_LINKS, WEBSITE_AUTHORS_PATH, WEBSITE_LEGAL_PATHS } from 'booksprout-app/src/constants'

export const WebsitePaths = {
  home: '/',
  // The author landing page. It lived at `home` until sc-28009 sent the root to the reviewer app's
  // review-copies list; `readers` is redirected the same way and its page is unrouted for now. Shared
  // with the reviewer app, whose signed-out header links here.
  authors: WEBSITE_AUTHORS_PATH,
  readers: '/readers',
  pricing: '/pricing',
  about: '/about-us',
  login: '/publisher/login',
  signUp: '/publisher/sign-up',
  // The legal pages and the store links are shared with the author and reader apps' footer [sc-29060].
  privacyPolicy: WEBSITE_LEGAL_PATHS.privacyPolicy,
  terms: WEBSITE_LEGAL_PATHS.terms,
  affiliateDisclosure: WEBSITE_LEGAL_PATHS.affiliateDisclosure,
  cookiePolicy: WEBSITE_LEGAL_PATHS.cookiePolicy,
  reviewCopies: '/reviewer/review-copies',
  // Leading slashes, like every other page path here. These three were relative, which resolved the
  // same way as route children of '/' but produced "http://localhostaffiliate-program" wherever a path
  // was concatenated onto the origin — the canonical links on two public pages pointed at another host.
  privacyPolicyAllProducts: '/privacy-policy-all-products',
  affiliateProgram: '/affiliate-program',
  affiliateTermsAndConditions: '/affiliate-terms-and-conditions',
  appleLink: APP_STORE_LINKS.apple,
  googlePlayLink: APP_STORE_LINKS.googlePlay,
  amazonLink: APP_STORE_LINKS.amazon
}
